/**
 * 직종 마스터 — API 캐시 + 폴백
 * 관리자 직종관리에서 CRUD, 인사/사원 폼은 활성 목록만 사용
 */
import { ref, computed } from 'vue';
import { employeeApi } from '@/services/api';
import {
  EMPLOYEE_POSITION_OPTIONS,
  PRODUCTION_WORKER_POSITION_KEYWORDS,
} from '@/constants/employeePositions';

const names = ref<string[]>([...EMPLOYEE_POSITION_OPTIONS]);
const productionNames = ref<string[]>([...PRODUCTION_WORKER_POSITION_KEYWORDS]);
const loaded = ref(false);
const loading = ref(false);
let loadPromise: Promise<void> | null = null;

export async function loadJobTypes(force = false): Promise<void> {
  if (loaded.value && !force) return;
  if (loadPromise && !force) return loadPromise;

  loading.value = true;
  loadPromise = (async () => {
    try {
      const res = await employeeApi.getJobTypes();
      const data = res.data?.data;
      const nextNames = Array.isArray(data?.names) ? data.names.filter(Boolean) : [];
      const nextProd = Array.isArray(data?.productionNames)
        ? data.productionNames.filter(Boolean)
        : [];
      if (nextNames.length) names.value = nextNames;
      if (nextProd.length) productionNames.value = nextProd;
      loaded.value = true;
    } catch (e) {
      console.warn('직종 목록 로드 실패 — 기본 목록 사용', e);
      if (!names.value.length) names.value = [...EMPLOYEE_POSITION_OPTIONS];
    } finally {
      loading.value = false;
      loadPromise = null;
    }
  })();

  return loadPromise;
}

export function useJobTypes() {
  const positionOptions = computed(() => names.value);
  const productionOptions = computed(() => productionNames.value);
  const defaultPosition = computed(() => names.value[0] || '요양보호사');

  const isEmployeePosition = (value: string | null | undefined): boolean => {
    if (!value) return false;
    return names.value.includes(value);
  };

  const isProductionWorkerPosition = (position: string | null | undefined): boolean => {
    if (!position) return false;
    return productionNames.value.some((p) => position.includes(p));
  };

  return {
    positionOptions,
    productionOptions,
    defaultPosition,
    loaded,
    loading,
    loadJobTypes,
    isEmployeePosition,
    isProductionWorkerPosition,
  };
}
